import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { DatabaseProvider } from '../database/database';
import { Collection } from 'lokijs';
import { LoginProvider } from '../login/login';
/*
  Generated class for the ListProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ListProvider {
  // private listDB: Loki;
  private list: Collection;

  constructor(public http: HttpClient, public storage: Storage, public db: DatabaseProvider) {
    this.list = db.getCollection('communicoList');
  }

  public async getList(listType: string) {
    return this.list.find({ type: listType });
  }

  public async addToList(listType: string, value: any) {
    let duplicate = false;

    await this.getList(listType).then((res) => {
      res.forEach(item => {
        if (listType === 'events' && item.value.eventId === value.eventId) {
          duplicate = true;
        } else if (listType === 'allUsers' && item.value.id === value.id) {
          duplicate = true;
        }
      });
    });

    if (duplicate) {
      return { success: false, errorMsg: 'This item is already in your list.' };
    }

    try {
      this.list.insertOne({ type: listType, value: value });
      await this.db.saveDB();
    //   console.log(this.list, this.db);
      return { success: true, errorMsg: '' };
    }
    catch (err) {
      return { success: false, errorMsg: err };
    }
  }

  public async removeFromList(listToRemove: Array<any>, listType: string) {
    try {
      listToRemove.forEach(id => {
        if (listType === 'events') {
          this.list.findAndRemove({"value.eventId":id});
        }
      });
      await this.db.saveDB();
      return { success: true, errorMsg: '' };
    } catch (err) {
      return { success: false, errorMsg: err }
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/list/list.ts